import Button from "../Button";

import makeRangeText from "./range-text";
import { FilterSummaryProps } from "./types";

const DataFilterSummary = ({
  type,
  filter,
  index = 0,
  removeFilter,
  editFilter,
  skipCondition,
}: FilterSummaryProps) => {
  index = index || 0;

  const { column, condition } = filter;

  const conditionText =
    condition === "include" ? "Include only" : "Exclude all";

  const rangeText = makeRangeText(filter, type);

  return (
    <span>
      {index >= 1 && `${index}. `}
      {!skipCondition && <>{conditionText} rows where</>} <i>{column}</i>{" "}
      {rangeText}{" "}
      {removeFilter && (
        <Button onClick={removeFilter} color="primary" size="small">
          Remove
        </Button>
      )}
      {editFilter && (
        <Button onClick={editFilter} color="primary" size="small">
          Edit
        </Button>
      )}
    </span>
  );
};

export default DataFilterSummary;
